"use client";

import React, { useEffect, useState, useRef } from "react";
import { motion, useInView } from "framer-motion";

const CounterAnimation = ({ target, suffix = "", label, duration = 2 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (isInView) {
      let startTime = null;
      const animate = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const progress = Math.min(
          (currentTime - startTime) / (duration * 1000),
          1
        );

        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        setCount(Math.floor(easeOutQuart * target));

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    }
  }, [isInView, target, duration]);

  return (
    <motion.div
      ref={ref}
      className="text-center"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={isInView ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.8 }}
    >
      <motion.div
        className="text-3xl md:text-7xl font-bold text-[#dfa428] mb-4 flex justify-center text-center"
        animate={isInView ? { scale: [1, 1.1, 1] } : {}}
        transition={{ duration: 0.6, delay: 0.5 }}
      >
        {count}
        {suffix}
      </motion.div>
      <div className="text-sm md:text-xl text-center flex justify-center">
        {label}
      </div>
    </motion.div>
  );
};

export default CounterAnimation;
